import { Component, Input } from "@angular/core"

@Component({
    selector: "app-testimonial",
    templateUrl: "./testimonial.component.html",
    styleUrls: ["./testimonial.component.scss"],
    standalone: false,
})
export class TestimonialComponent {}
